import {apiHttpClient} from "@/http/httpClient";
import type {PaginationItems} from "@/models/pagination";
import type {UpdateUserLanguageRequest, UpdateUserStatusRequest, UpdateUserTableDensityRequest, User, UserListRequest} from "@/models/user/user";
import {Language} from "@/constants/language";
import { TableDensity } from '@/constants/density-size';
import {RelationDropdownModel} from "@/models/relation/relation";

const ENDPOINT_LIST_USERS = 'User/List';
const ENDPOINT_CREATE_USER = 'User/Create';
const ENDPOINT_UPDATE_USER = 'User/Update';
const ENDPOINT_UPDATE_USER_LANGUAGE = 'User/UpdateLanguage';
const ENDPOINT_UPDATE_USER_TABLE_DENSITY = 'User/UpdateTableDensity';
const ENDPOINT_UPDATE_USER_STATUS = 'User/UpdateStatus';
const ENDPOINT_GET_USER_LANGUAGE = 'User/Language';
const ENDPOINT_GET_USER_TABLE_DENSITY = 'User/TableDensity';
const ENDPOINT_GET_USER_RELATIONS = 'User/Relations';

export const getUsers = (request: UserListRequest) => {
    return apiHttpClient().post<PaginationItems<User>>(ENDPOINT_LIST_USERS, request)
        .then(response => {
            return response;
        })
        .catch(error => {
            return error;
        })
}

export const createUser = (request: User) => {
    return apiHttpClient().post(ENDPOINT_CREATE_USER, request)
        .then(response => {
            return response;
        })
        .catch(error => {
            return error;
        })
}

export const updateUser = (request: User) => {
    return apiHttpClient().put(ENDPOINT_UPDATE_USER, request)
        .then(response => {
            return response;
        })
        .catch(error => {
            return error;
        })
}

export const updateUserStatus = (request: UpdateUserStatusRequest) => {
    return apiHttpClient().put(ENDPOINT_UPDATE_USER_STATUS, request)
        .then(response => {
            return response;
        })
        .catch(error => {
            return error;
        })
}

export const updateUserLanguage = (request: UpdateUserLanguageRequest) => {
    return apiHttpClient().post(ENDPOINT_UPDATE_USER_LANGUAGE, request)
        .then(response => {
            return response;
        })
        .catch(error => {
            return error;
        })
}

export const updateUserTableDensity = (request: UpdateUserTableDensityRequest) => {
    return apiHttpClient().post(ENDPOINT_UPDATE_USER_TABLE_DENSITY, request)
        .then(response => {
            return response;
        })
        .catch(error => {
            return error;
        })
}

export const getUserLanguage = (userId: string) => {
    return apiHttpClient().get<Language>(ENDPOINT_GET_USER_LANGUAGE + `/${userId}`)
        .then(response => {
            return response.data;
        })
        .catch(error => {
            return Language.enUS;
        })
}

export const getUserTableDensity = (userId: string) => {
    return apiHttpClient().get<TableDensity>(ENDPOINT_GET_USER_TABLE_DENSITY + `/${userId}`)
        .then(response => {
            return response;
        })
        .catch(error => {
            return error;
        })
}

export const getUserRelations = (userId: string) => {
    return apiHttpClient().get<RelationDropdownModel[]>(ENDPOINT_GET_USER_RELATIONS + `/${userId}`)
        .then(response => {
            return response;
        })
        .catch(error => {
            return error;
        })
}